// Types
import type { ApplicationProps } from '@/types/config'

const Config: ApplicationProps = {
	name: 'Tłı̨chǫ History',
	shortName: 'tlicho-history'
}

export default Config
